import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ValidTimeSettingComponent } from './valid-time-setting.component';

const routes: Routes = [
  {path: '', component: ValidTimeSettingComponent},
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ValidTimeSettingRoutingModule { }
